<div id="merge-split-headings" class="m-3">

    <h1>Unir / dividir enunciados</h1>

    <div id="headings-action">
        <p class="fw-bold">¿Qué desea hacer?</p>
        <label for="headings-action-merge" class="d-block">
            <input type="radio" name="headings-action" id="headings-action-merge" value="merge" [(ngModel)]="headingsAction">
            <span class="ms-2">Unir varios enunciados en uno solo</span>
        </label>
    
        <label for="headings-action-split" class="d-block">
            <input type="radio" name="headings-action" id="headings-action-split" value="split" [(ngModel)]="headingsAction">
            <span class="ms-2">Dividir un enunciado en varios</span>
        </label>
    </div>
    
    <div id="headings-source">
        <label for="course-units"  class="d-block" *ngIf="courseUnits.length > 0 && headingsAction != ''">
            <p class="fw-bold">Unidad:</p>
            <select #courseUnitsSelect name="course-units" id="course-units" [(ngModel)]="selectedUnit"
                (ngModelChange)="selectUnit($event)">
                <option disabled selected value="-1">Seleccione una unidad...</option>
                <option *ngFor="let unit of courseUnits" value="{{ unit.id }}">
                    {{ unit.name }}
                </option>
            </select>
        </label>
        
        <label for="units-lessons" class="d-block" *ngIf="unitLessons.length > 0 && headingsAction != ''">
            <p class="fw-bold">Lección:</p>
            <select #unitLessonsSelect name="unit-lessons" id="unit-lessons" [(ngModel)]="selectedLesson"
                (ngModelChange)="selectLesson($event)">
                <option disabled selected value="-1">Seleccione una lección...</option>
                <option *ngFor="let lesson of unitLessons" value="{{ lesson.id }}">
                    {{ lesson.name }}
                </option>
            </select>
        </label>
    </div>

    <div *ngIf="selectedLesson != -1">
        <p *ngIf="lessonHeadings.length == 0" class="mt-3">
            Esta lección no tiene enunciados.
        </p>

        <p *ngIf="headingsAction === 'merge' && lessonHeadings.length <= 1" class="mt-3">
            Esta lección sólo tiene un enunciado.
        </p>
        
        <ul id="merge-headings-list" *ngIf="headingsAction === 'merge' && lessonHeadings.length > 1">
            <button class="btn btn-primary m-3" *ngIf="selectedLesson > -1" (click)="selectAllHeadings()">
                <i class="fa fa-check-square"></i>
                <span>Seleccionar todo</span>
            </button>
            <li *ngFor="let heading of lessonHeadings; let i = index;">
                <label for="headings_{{ i }}">
                    <input type="checkbox" id="headings_{{ i }}" name="headings" value="{{ heading.id }}" (click)="selectHeading(heading.id, heading.name)" [attr.checked]="selectedHeadings.includes(heading) ? 'checked' : null">
                    <span class="ms-2">{{ heading.name }}</span>
                </label>
            </li>
        </ul>

        <ul id="split-headings-list" *ngIf="headingsAction === 'split' && lessonHeadings.length > 1">
            <p class="fw-bold">Seleccione el enunciado a dividir:</p>
            <li *ngFor="let heading of lessonHeadings; let i = index;">
                <label for="headings_{{ i }}">
                    <input type="radio" id="headings_{{ i }}" name="headings" value="{{ heading.id }}"
                        (click)="selectHeading(heading.id, heading.name)"
                        [attr.checked]="selectedHeadings.includes(heading) ? 'checked' : null">
                    <span class="ms-2">{{ heading.name }}</span>
                </label>
            </li>
        </ul>

    </div>

    <div id="new-heading">
        <label for="new-heading-name" class="d-block" *ngIf="headingsAction === 'merge' && newHeadingName != ''">
            <p class="fw-bold">Título del nuevo enunciado:</p>
            <input type="text" id="new-heading-name" [(ngModel)]="newHeadingName">
        </label>
        <label for="split-chars" class="d-block" *ngIf="headingsAction === 'split' && selectedHeadingsText">
            <p class="fw-bold">Carácteres de separación (pueden cambiarse):</p>
            <input type="text" id="split-chars" [(ngModel)]="splitChars">
        </label>
        <label for="new-heading-content-editor" *ngIf="selectedHeadingsText">
            <p *ngIf="headingsAction === 'merge'">Contenido del nuevo enunciado:</p>
            <p *ngIf="headingsAction === 'split'">Contenido del enunciado existente (copie y pegue los caracteres de separación para dividir los enunciados):</p>
            <tinymce-editor [id]="'new-heading-content-editor'" [content]="selectedHeadingsText"></tinymce-editor>
        </label>
    </div>

    <div id="merge-split-headings-status" class="form-group text-center">
        <div id="merge-split-headings-spinner" *ngIf="mergeLoading || splitLoading">
            <i class="fa fa-spinner fa-spin"></i>
            <span>Procesando, espere por favor...</span>
        </div>
        <div id="merge-headings-error" class="text-danger" *ngIf="mergeError">
            <i class="fa fa-times"></i>
            <span>Hubo un error, no se unieron los enunciados. Por favor, inténtelo de nuevo.</span>
        </div>
        <div id="merge-headings-success" class="text-success" *ngIf="mergeSuccess">
            <i class="fa fa-check"></i>
            <span>Se han unido los enunciados correctamente.</span>
        </div>
        <div id="split-headings-error" class="text-danger" *ngIf="splitError">
            <i class="fa fa-times"></i>
            <span>Hubo un error, no se dividieron los enunciados. Por favor, inténtelo de nuevo.</span>
        </div>
        <div id="split-headings-success" class="text-success" *ngIf="splitSuccess">
            <i class="fa fa-check"></i>
            <span>Se ha dividido el enunciado correctamente.</span>
        </div>
    </div>
    
    <div id="merge-headings-buttons" class="form-group">
        <button class="btn btn-primary m-3" routerLink="/course/{{ courseID }}" routerLinkActive="active">
            <i class="fa fa-arrow-left"></i>
            <span>Volver</span>
        </button>
    
        <button id="merge-headings-btn" class="btn btn-success m-3" (click)="mergeHeadings()" *ngIf="headingsAction === 'merge'" [attr.disabled]="mergeBtnDisabled ? 'disabled' : null">
            <i class="fas fa-align-center"></i>
            <i class="fa fa-plus"></i>
            <i class="fas fa-align-center"></i>
            <span>Unir enunciados</span>
        </button>

        <button id="split-headings-btn" class="btn btn-success m-3" (click)="splitHeadings()" *ngIf="headingsAction === 'split'" [attr.disabled]="splitBtnDisabled ? 'disabled' : null">
            <i class="fas fa-align-center"></i>
            <i class="fa fa-divide"></i>
            <i class="fas fa-align-center"></i>
            <span>Dividir enunciados</span>
        </button>
    </div>
</div>